import { ROUTELIST } from './routes/routesList';
import RoutesWithErorrBoundary from './routes';
import { ConfigProvider } from 'antd';
import { createTheme } from './utils';
import Layout from './Layout';
import React, { useContext } from 'react';
import './App.css';
import { FileNavigationProvider } from './contexts/FileNavigationContext';
import { FileOperationsProvider } from './contexts/FileOperationsContext';
import { ThemeContext } from './context/themeProvider';

const theme = createTheme();

const App = () => {
  const { themeColor } = useContext(ThemeContext);
  return (
    <ConfigProvider theme={{ ...theme, token: { ...theme?.token, colorPrimary: themeColor, colorLink: themeColor } }}>
      <FileNavigationProvider>
        <FileOperationsProvider>
          <RoutesWithErorrBoundary routeList={ROUTELIST} />
        </FileOperationsProvider>
      </FileNavigationProvider>
    </ConfigProvider>
  );
};

export default App;
